export default {
    expertApiUrl: `https://expert-api.mysoluto.com/v1`,
};
